import React from 'react';
import { useReport } from '../contexts/ReportContext';
import { useTheme } from '@emotion/react';


const colorLevels = [
    '#A78BFA',
    '#8B5CF6',
    '#7C3AED'
];

interface CircularArcsProps {
    title: string;
    unit: string;
    level: number;
    size?: number;
    titleFontSize?: number;
    unitFontSize?: number;
}

const CircularArcs: React.FC<CircularArcsProps> = ({ title, unit, level, size = 200, titleFontSize = 20, unitFontSize = 12 }) => {

    const { colorStyle } = useReport();
    const theme: any = useTheme();

    return (

        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 119 113" fill="none">
            <mask id="mask0_188_262" maskUnits="userSpaceOnUse" x="0" y="0" width={size} height={size}>
                <rect x="-2.32278" y="-5.0498" width={size} height={size} fill="#C4C4C4" />
            </mask>
            <g mask="url(#mask0_188_262)">
                <path d={`M117.034 66.7619C121.24 47.4379 113.697 19.8646 90.4637 7.2923C63.377 -7.36546 22.2822 2.04993 8.07088 25.7662C-2.84302 41.6458 -4.19327 77.7236 23.1228 98.6474C58.5898 125.815 108.261 107.076 117.034 66.7619Z`} fill={theme.palette.reportColorStyles[colorStyle].light} />
                <path d={`M101.864 26.776C88.6054 6.88851 66.6095 2.06249 48.8101 6.7863C9.16733 ${(Math.random() * 20 + 10).toFixed(2)} 2.41746 57.3722 13.6863 78.2422C20.9778 91.7461 ${(Math.random() * 30 + 10).toFixed(3)} 106.277 74.962 103.178C104.789 100.078 121.381 ${(Math.random() * 50 + 30).toFixed(3)}  101.864 26.776Z`} fill={theme.palette.reportColorStyles[colorStyle].main} />
            </g>

            <text
                x="60"
                y="40"
                fontSize={titleFontSize}
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="middle"
                fill={theme.palette.reportColorStyles[colorStyle].text}
            >
                {title}
            </text>

            <text
                x="60"
                y="65"
                fontSize={unitFontSize}
                fontWeight="normal"
                textAnchor="middle"
                fill={theme.palette.reportColorStyles[colorStyle].text}
                dominantBaseline="middle"
            >
                {unit}
            </text>
        </svg>

    );
};

export default CircularArcs;